import * as Progress from '@radix-ui/react-progress'
import styles from './Bar.module.css'

interface BarProps {
  score: number
  label: string
}

export function Bar({ score, label }: BarProps) {
  return (
    <Progress.Root
      className={styles.progressRoot}
      value={score}
      aria-label={label}
    >
      <Progress.Indicator
        className={styles.progressIndicator}
        style={{ transform: `translateX(-${100 - score}%)` }}
      />
    </Progress.Root>
  )
}
